module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._l((_vm.couponCategoryList), function(item) {
    return _c('div', {
      staticClass: "list-category-card"
    }, [_c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeCouponCategory(item)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.categoryName))])])
  }), _vm._v(" "), _c('el-card', {
    staticClass: "add-btn",
    attrs: {
      "shadow": "never",
      "body-style": "padding: 0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addHandler.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dialogLoading),
      expression: "dialogLoading"
    }],
    attrs: {
      "title": "添加商品",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "placeholder": "请输入品类名称",
      "remote-method": _vm.searchCategory,
      "loading": _vm.categoryLoading
    },
    model: {
      value: (_vm.categoryData),
      callback: function($$v) {
        _vm.categoryData = $$v
      },
      expression: "categoryData"
    }
  }, _vm._l((_vm.categoryList), function(item) {
    return _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.categoryName,
        "value": item.categoryId
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addNewCouponCategory
    }
  }, [_vm._v("保存")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-278521cf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/coupon/components/couponCategory.vue
// module id = 1623
// module chunks = 0